import { render, staticRenderFns } from "./user_profiles.vue?vue&type=template&id=77544fbc&scoped=true&"
import script from "./user_profiles.vue?vue&type=script&lang=js&"
export * from "./user_profiles.vue?vue&type=script&lang=js&"
import style0 from "./user_profiles.vue?vue&type=style&index=0&id=77544fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77544fbc",
  null
  
)

export default component.exports